import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, playState } from "../../lib/api";
import { useI18n } from "../../i18n";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../../components/ui/alert-dialog";
import { PageHeader, Panel } from "./CareLayout";

const SOURCES = [
  ["mobile_touch_simulated", "MobileTouchInput", "Actif — position tactile = direction d'atteinte simulée"],
  ["vr_controller", "FutureVRInput", "Préparé — manettes Meta Quest 3/3S via OpenXR"],
  ["hand_tracking", "FutureHandTrackingInput", "Préparé — suivi des mains OpenXR"],
  ["body_tracking / external_sensor", "—", "Prévu — capteurs externes / suivi corporel"],
];

export default function Settings() {
  const { lang, setLang } = useI18n();
  const qc = useQueryClient();
  const reset = async () => { await api.post("/demo/reset"); playState.clear(); qc.invalidateQueries(); toast.success("Données de démonstration réinitialisées"); };
  return (
    <div data-testid="care-settings">
      <PageHeader title="Paramètres" />
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title="Langue de l'interface">
          <div className="flex flex-wrap gap-2">
            {[["fr", "Français"], ["en", "English"]].map(([k, l]) => (
              <button key={k} data-testid={`lang-${k}`} onClick={() => setLang(k)} className={`h-11 rounded-xl px-5 text-sm font-bold ${lang === k ? "bg-brand text-white" : "border border-border"}`}>{l}</button>
            ))}
          </div>
          <p className="mt-3 text-xs text-muted-foreground">Architecture i18n prête (FR par défaut). Traduction anglaise partielle dans ce prototype.</p>
        </Panel>
        <Panel title="Données de démonstration">
          <p className="mb-3 text-sm text-foreground/75">Réinitialise Patient Démo, ses 4 séances historiques simulées et la progression du jeu.</p>
          <AlertDialog>
            <AlertDialogTrigger asChild><button data-testid="reset-demo-button" className="h-11 rounded-xl bg-red-600 px-5 text-sm font-bold text-white">Réinitialiser la démo</button></AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader><AlertDialogTitle>Réinitialiser toutes les données ?</AlertDialogTitle><AlertDialogDescription>Toutes les séances, calibrations et patients créés seront supprimés.</AlertDialogDescription></AlertDialogHeader>
              <AlertDialogFooter><AlertDialogCancel>Annuler</AlertDialogCancel><AlertDialogAction data-testid="reset-demo-confirm" onClick={reset} className="bg-red-600">Réinitialiser</AlertDialogAction></AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </Panel>
        <Panel title="Sources d'entrée du mouvement" className="lg:col-span-2" testId="input-sources">
          <div className="overflow-x-auto"><table className="w-full min-w-[520px] text-sm"><tbody>
            {SOURCES.map(([k, c, d]) => <tr key={k} className="border-t border-border/60"><td className="py-2 font-mono text-xs">{k}</td><td className="font-mono text-xs">{c}</td><td>{d}</td></tr>)}
          </tbody></table></div>
          <p className="mt-3 text-xs text-muted-foreground">Les données tactiles sont étiquetées « DONNÉES DE MOUVEMENT SIMULÉES » et ne constituent pas une capture clinique du mouvement. Plan de séance exposé en JSON : <code className="font-mono">GET /api/sessions/&#123;id&#125;</code> (champ <code>plan</code>).</p>
        </Panel>
      </div>
    </div>
  );
}
